import { FiChevronDown } from "react-icons/fi";
import type { SortType } from "@/features/catalog/stores/catalogStore";
import { CATALOG_SORT_OPTIONS } from "@/features/catalog/utils/catalogSortOptions";
import { selectDesktopSort } from "@/features/catalog/utils/desktopCatalogSort";

type Props = {
  currentSort: SortType;
  selectSortMethod: (sort: SortType) => void;
};

export function DesktopCatalogSortNavigation({
  currentSort,
  selectSortMethod,
}: Props): React.ReactElement {
  return (
    <label className="desktop-catalog-sort">
      表示 :
      <select
        aria-label="表示順"
        value={currentSort}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>): void => {
          selectDesktopSort(
            currentSort,
            event.currentTarget.value as SortType,
            selectSortMethod,
          );
        }}
      >
        {CATALOG_SORT_OPTIONS.map(({ label, sort }) => (
          <option key={sort} value={sort}>
            {label}
          </option>
        ))}
      </select>
      <FiChevronDown aria-hidden="true" />
    </label>
  );
}
